export default () => ({
  data        : [],
  totalCount  : 0,
  totalUnread : 0,
  page        : 0
});
